import { render } from "./ManageChatbotsPage.vue?vue&type=template&id=07cb79e4&scoped=true"
import script from "./ManageChatbotsPage.vue?vue&type=script&lang=js"
export * from "./ManageChatbotsPage.vue?vue&type=script&lang=js"

import "./ManageChatbotsPage.vue?vue&type=style&index=0&id=07cb79e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cb79e4"]])

export default __exports__